<agr-page-toolbar [pageTitle]="'app.employee.navigation.details' | translate"></agr-page-toolbar>
<section class="spacing--padding-all" data-test="employee-detail">
  <ng-container [agrBlockSpinner]="employee() === undefined">
    @if (employee(); as employee) {
      <div class="employee-detail__header">
        <div>
          <div class="employee-detail__name" data-test="employee-detail__name">
            {{ getName(employee) }}
          </div>
          <div class="employee-detail__subtitle" data-test="employee-detail__user-name">
            {{ employee.userName }}
          </div>
        </div>
        <span
          class="employee-detail__status"
          [class.employee-detail__status--inactive]="!employee.isActive"
          data-test="employee-detail__status"
        >
          {{
            employee.isActive
              ? ('app.employee.detail.active' | translate)
              : ('app.employee.detail.inactive' | translate)
          }}
        </span>
      </div>

      <div class="employee-detail__sections">
        <section class="employee-detail__section">
          <div class="text--h5">{{ 'app.employee.detail.title_general' | translate }}</div>
          <dl class="employee-detail__grid">
            <div class="employee-detail__item">
              <dt>{{ 'app.employee.detail.first_name' | translate }}</dt>
              <dd data-test="employee-detail__first-name">{{ employee.firstName || '-' }}</dd>
            </div>
            <div class="employee-detail__item">
              <dt>{{ 'app.employee.detail.last_name' | translate }}</dt>
              <dd data-test="employee-detail__last-name">{{ employee.lastName || '-' }}</dd>
            </div>
          </dl>
        </section>

        <section class="employee-detail__section">
          <div class="text--h5">{{ 'app.employee.detail.title_contact' | translate }}</div>
          <dl class="employee-detail__grid">
            <div class="employee-detail__item">
              <dt>{{ 'app.employee.detail.email' | translate }}</dt>
              <dd data-test="employee-detail__email">{{ employee.email || '-' }}</dd>
            </div>
            <div class="employee-detail__item">
              <dt>{{ 'app.employee.detail.mobile_number' | translate }}</dt>
              <dd data-test="employee-detail__mobile-number">
                {{ employee.mobileNumber || '-' }}
              </dd>
            </div>
          </dl>
        </section>
      </div>
    }
  </ng-container>
</section>
